
<script>
import { mapGetters, mapActions } from 'vuex'

/**
 * Components
 *
 */
import DeleteDialog from '@/components/uicomp/ModalDialog-Delete'
import TableOptionsDialog from './ListOptionsDialog'
const components = {
  DeleteDialog,
  TableOptionsDialog,
}

/**
 * Static Data
 *
 */
const data = function () {
  return {
  }
}

/**
 * Computed
 *
 */
const computed = mapGetters({
  list: `Product/Category/list`,
  meta: `Product/Category/listMeta`,
})

/**
 * Methods
 *
 */
const methods = mapActions({
  setListOption: `Product/Category/setListOption`,
  reload: `Product/Category/fetchList`,
  pagePrev: `Product/Category/pagePrev`,
  pageNext: `Product/Category/pageNext`,
  deleteItem: `Product/Category/remove`,
})

methods.edit = function (id) {
  this.$emit(`editrequest`, id)
}

methods.showopt = function () {
  this.$refs.TableOptionsDialog.show()
}

methods.search = function (value) {
  this.setListOption({ search: value })
}

/**
 * Watch
 *
 */
const watch = {
  meta: {
    deep: true,
    handler(n, o) {
      n.version !== o.version && this.reload()
    },
  }
}

/**
 * Event OnMounted
 *
 */
const mounted = async function() {
  this.setListOption({ format: `deep` })
}

/**
 * Event OnCreated
 *
 */
const created = async function() {
  //
}

/**
 * Event Socket
 *
 */
const sockets = {
}

export default {
  components,
  data,
  computed,
  methods,
  watch,
  mounted,
  created,
  sockets,
}
</script>

<style scoped>
</style>

<template>
  <Row>
    <TableOptions
      :nrecord="meta.nrecord"
      :npage="meta.npage"
      :curpage="meta.curpage"
      :searchValue="meta.filter.search"
      @nextpage="pageNext"
      @prevpage="pagePrev"
      @showopt="showopt"
      @search="search"
    />
    <TableOptionsDialog ref="TableOptionsDialog"
    />

    <TableList>
      <template #head>
        <th width="40" class="text-center">#</th>
        <th class="text-left">Nama Kategori</th>
        <!-- <th width="200" class="text-right">Komisi Reseller</th> -->
        <th width="200" class="text-right">Jumlah Produk</th>
        <th width="40" class="text-right"></th>
      </template>

        <template #body>
        <tr v-for="(item, index) in list" :key="item.id">
          <td class="text-center" v-html="index + meta.curstart"></td>
          <td class="text-left">
            <span class="link underlined" @click="edit(item.id)">{{ item.name }}</span>
          </td>
          <!-- <td class="text-right">{{ item.resell_commission_readable }} %</td> -->
          <td class="text-right">{{ item.product_count }} item</td>
          <td class="text-right">
            <TButtonDelete @click="$refs.DeleteDialog.confirm(item.id, item.name)" />
          </td>
        </tr>
      </template>
    </TableList>

    <DeleteDialog ref="DeleteDialog" @submit="deleteItem($event)" />
  </Row>
</template>